import { useEffect, useRef } from "react";

const useListenCustomEvent = (
  eventType: string,
  eventCallback: (event: Event) => void
) => {
  const savedCallback = useRef<(event: Event) => void>();

  useEffect(() => {
    savedCallback.current = eventCallback;
  }, [eventCallback]);

  useEffect(() => {
    const handler = (event: Event) => {
      if (savedCallback.current) {
        savedCallback.current(event);
      }
    };

    window.addEventListener(eventType, handler);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener(eventType, handler);
    };
  }, [eventType]);
};

export default useListenCustomEvent;
